import React from 'react'
import { LazyMotion, domAnimation } from 'framer-motion'

/**
 * Root wrapper for framer-motion.
 *
 * Every `motion.*` component drags framer's full feature set into the bundle —
 * including drag gestures and layout animation, which this site never uses. The
 * lightweight `m.*` components ship no features of their own and pick them up
 * from this provider instead, so the feature code is loaded once rather than
 * being pulled in by each of the ~50 components that animate.
 *
 * `domAnimation` covers animations, variants, exit animations, `whileInView`
 * and hover/tap/focus gestures. If a component ever needs `drag`, `layout` or
 * `layoutId`, this has to become `domMax` — `strict` makes that failure loud:
 * it throws on any remaining `motion.*` usage rather than silently shipping the
 * full bundle again.
 */
export default function MotionProvider({ children }: { children: React.ReactNode }) {
  return (
    <LazyMotion features={domAnimation} strict>
      {children}
    </LazyMotion>
  )
}
